import React, { Component } from "react"
import _ from "lodash"
import { connect } from "react-redux"
import { loadingStatus, getPayload } from "actions"
import { bindActionCreators } from "redux"
import submitData from "helpers/submitData"

class RemoveClosing extends Component {
	constructor(props) {
		super(props)
		this.state = {}
	}

	componentDidMount() {}

	delete() {
		submitData("mainIngest", { action: "removeClosing", sale_id: this.props.sale.id })
			.then((data) => {
				this.props.notify(data, this.props.name)
			})
			.catch((e) => {
				this.props.notify(e, this.props.name)
			})
	}

	render() {
		return (
			<div className="modal">
				<h3>Remove Closing: {this.props.data.address}</h3>
				<div className="flex pt-8">
					<div className="btn mr-2 !bg-red-500 !border-red-500" onClick={() => this.delete()}>
						Confirm Closing Removal
					</div>
				</div>
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		trafficSources: state.trafficSources,
		payload: state.payload,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			getPayload,
			loadingStatus,
		},
		dispatch
	)
}

export default connect(mapStateToProps, matchDispatchToProps)(RemoveClosing)
